/** venture/RepAnnual.tsx — 결산보고 1건(사업연도 y)의 첨부 준비 (2026-09-24)
 *  감사의견서 면제 판정(① 투자실적 변동 없음 체크 ② 결성 3년 내·출자금 2억 이하) → 면제면 자금운용현황 자동 작성,
 *  아니면 결산서·회계법인 감사의견서 업로드. VICS [1340]에 첨부 후 저장. */
import React from 'react';
import { getUp, getUpKey, mutStore, UpLabel, renameUpload, dispName } from './stepcommon';
import { s3upload } from './api';
import { openS3, downloadUploadFile } from './docgen';
import { auditRule, AUDIT_CAP } from './report';
import { won, fmtWon } from './coterms';
import FundStatusForm from './FundStatusForm';
import type { Project } from './types';

interface Props { p: Project; y: number; onPatch: (patch: Partial<Project>) => void; toast: (m: string) => void; }

export default function RepAnnual({ p, y, onPatch, toast }: Props) {
  const rule = auditRule(p, y);
  const key = 'fin_' + y + '_audit';
  const name = getUp(p, 's15', key); const s3key = getUpKey(p, 's15', key);
  const toggleNoChange = () => onPatch(mutStore(p, 's15', (s) => { s.chk = s.chk || {}; s.chk['nochange_' + y] = !s.chk['nochange_' + y]; }));
  const docName = y + '년 결산서·감사의견서';
  const upload = async (f0: File) => {
    try {
      const r = await s3upload(p.id, renameUpload(f0, docName, p.org || ''));
      onPatch(mutStore(p, 's15', (st) => { st.up[key] = r.name; st.upKey = st.upKey || {}; st.upKey[key] = r.key; }));
      toast('업로드됨 · ' + r.name);
    } catch (e) { toast((e as Error).message); }
  };
  const remove = () => onPatch(mutStore(p, 's15', (st) => { if (st.up) delete st.up[key]; if (st.upKey) delete st.upKey[key]; }));
  const total = won(p.total);
  return (
    <div className="repannual">
      <div className={'chkrow ' + (rule.noChange ? 'on' : '')} onClick={toggleNoChange}>
        <span className="chkbox">{rule.noChange ? '✓' : ''}</span><b>{y} 사업연도 투자실적 변동 없음</b><span className="grow" />
        <span className="chklabel">{rule.noChange ? '감사의견서 면제 ①' : '변동 있음'}</span>
      </div>
      <div className={'s3file ' + (rule.exempt ? 'ok' : '')} style={{ marginTop: 6, flexWrap: 'wrap' }}>
        <span className="rf" style={{ whiteSpace: 'normal', flex: '1 1 260px' }}>
          {rule.exempt ? '✅ 회계법인 감사의견서 불필요 — ' + rule.reasons.join(' / ') : '📑 결산서 + 회계법인 감사의견서 필요 (개인 회계사 불가)'}
        </span>
        <span className="grow" />
        <span className={'pill ' + (rule.within3y && rule.small ? 'p-green' : 'p-gray')} title="결성 후 3년이 지나지 않은 조합으로 출자금 총액 2억원 이하">
          {rule.within3y ? '결성 3년 내' : '결성 3년 경과'} · 출자금 {total ? fmtWon(total) : '미입력'} {rule.small ? '≤' : '>'} {fmtWon(AUDIT_CAP)}
        </span>
      </div>
      {rule.exempt ? (
        <FundStatusForm p={p} y={y} onPatch={onPatch} toast={toast} />
      ) : (
        <div className="codoc" style={{ marginTop: 8 }}>
          <div className="codoc-h"><span>결산서 · 회계법인 감사의견서 <span className="s2tag">VICS [1340] 첨부용 · 정해진 형식 없음</span></span></div>
          {name ? (
            <div className="s3file ok"><span className="rf">📄 {name}</span><span className="pill p-green">업로드됨</span><span className="grow" />
              <button className="rbtn" onClick={() => openS3(s3key, name, true).catch((e) => toast((e as Error).message))}>👁 보기</button>
              <button className="rbtn" onClick={() => downloadUploadFile(p, s3key, dispName(name, docName, p.org || ''), toast)}>⬇</button>
              <UpLabel text="다시" onUp={upload} />
              <button className="rbtn danger" onClick={remove}>🗑</button></div>
          ) : <UpLabel text="⬆ 결산서·감사의견서 업로드 (또는 드래그)" onUp={upload} />}
        </div>
      )}
      <div className="snote" style={{ marginTop: 8 }}>VICS [1340] 개인투자조합 결산보고 → 「입력」 → 기준연도 {y} · 조합 선택 → 첨부파일 추가 → 창 닫고 「저장」</div>
    </div>
  );
}
